import { createSelector } from 'reselect';

export const getBasename = (state) => state.app.basename;
export const getHub = (state) => state.app.hub;
export const getReduxForms = (state) => state.form;
export const getAppURI = createSelector(getBasename, (basename) => window.location.host + basename);
